import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTerminal, FaTiktok, FaYoutube } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6"
import Navbar from "../components/Navbar";
import FootBar from "../components/FootBar";
import Topbar from "../components/Topbar";

const Contact = () => {
    return ( 
        <div className="contact h-max w-full bg-white">
            <Topbar/>
            <Navbar/>
            <div className="body md:flex p-4 mt-7 md:justify-around md:mx-auto md:px-auto md:max-w-6xl md:mt-10">
                <div className="space-y-4 w-full pt-7 md:overflow-y-auto md:w-1/2 md:py-2">
                    <h1 className="flex space-x-2 text-black text-3xl md:text-6xl"><span><FaTerminal className="text-yellow-500"/></span><b  id="txtHead" class="ease-in duration-500" >Contact_Us</b></h1>
                    <p className="text-black font-semibold text-lg text-justify ease-in duration-500">We'd love to hear from you! Feel free to reach out to us using the contact form below or any of the phone numbers listed.
                        <br />
                        Have a question or need assistance? Fill out the form below, and we’ll get back to you as soon as possible. reach us on 
                        any of our lines : 
                        <br />
                        09154593442, 09154593440, 07063062378, 09154593439, 08065371493
                    </p>
                    <ul className="flex md:pt-2">
                        <Link to="https://www.facebook.com/share/1CfCnyYDvU/?mibextid=LQQJ4d">
                            <FaFacebook className="text-2xl md:text-3xl hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.instagram.com/gloryandpraise1/profilecard/?igsh=MXRsZDg5dWtiaHhibQ==">
                            <FaInstagram className="text-2xl md:text-3xl ml-4 md:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.tiktok.com/@gppaf1?_t=8qCvY9MGpxl&_r=1">
                            <FaTiktok className="text-2xl md:text-3xl ml-4 md:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://twitter.com/gloryandpraise1">
                            <FaSquareXTwitter className="text-2xl md:text-3xl ml-4 md:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                        <Link to="https://www.youtube.com/channel/UCZqUadHISmghNq1bIkGaFWQ">
                            <FaYoutube className="text-2xl md:text-3xl ml-4 md:ml-20 hover:text-yellow-500 ease-in duration-500" />
                        </Link>
                    </ul>
                    <p class="font-medium text-yellow-600 text-justify">gloryandpraise.primefoundation@gmail.com</p>
                    <div class="py-2 md:hidden">
                        <form action="">
                            <input className="w-full text-black p-2 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="text"
                                placeholder="Name"/> <br/>
                            <input className="w-full text-black p-2 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="email"
                                placeholder="Email"/> <br/>
                            <textarea className="w-full text-black p-2 placeholder:-translate-y-0 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="text"
                                rows="10" cols="5" placeholder="Your message"></textarea> <br/>
                            <button id="txtBod6"
                                className="w-full p-2 text-lg border-2 text-white font-bold border-yellow-500 bg-gray-700 hover:bg-yellow-600 rounded-lg ease-in duration-500 mt-4">Send message</button>
                        </form>
                    </div>
                </div>
                <div class="p-2 hidden md:block md:w-1/3">
                    <form>
                        <input className="w-full text-gray-50 p-2 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="text"
                            placeholder="Name"/> <br/>
                        <input className="w-full text-gray-50 p-2 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="email"
                            placeholder="Email"/> <br/>
                        <textarea className="w-full text-gray-50 p-2 border-2 border-yellow-500 bg-gray-700 rounded-lg ease-in duration-500 mt-4" type="text"
                            rows="10" cols="5" placeholder="Your message"></textarea> <br/>
                        <button
                            className="w-full p-2 text-lg border-2 text-white font-bold border-yellow-500 bg-gray-700 hover:bg-yellow-600 rounded-lg ease-in duration-500 mt-4">Send message</button>
                    </form>
                </div>
            </div>
            <FootBar/>
        </div>
     );
}
 
export default Contact;